import React, { Fragment, useState, useEffect } from 'react';

// Components
import SampleSolutionBox from './common/SampleSolutionBox';

// Icons
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';

// Imgs
import auth_page_pic from '../util/imgs/auth_page_pic.JPG';
import screenshot_ft from '../util/imgs/screenshot_ft.png';

// Videos
import demo_6 from '../util/videos/demo_6.mp4';
  
const HowTo = () =>  {

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    
    useEffect(() => {
        
        // Add event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());

        // Cleanup the event listener when the component unmounts
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);

    // Update window width state on window resize
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };

    // Check if the device is mobile or tablet
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1024;

	return (
        <Fragment>
            {/* Section 1 - Header */}
            <div style={{padding: '1rem', marginLeft: 'auto', marginRight: 'auto', width: '100%', maxWidth: '1280px'}}>
                {/* Section Header */}
                <div style={{textAlign: 'center', marginBottom: '2rem'}}>
                    {/* Title - Header */}
                    <h2 style={{fontSize: `${isMobile ? '2.25rem' : '3rem'}`, fontWeight: 'bold', marginBottom: '1rem'}}>
                        How to Use
                    </h2>
                    {/* Description - Header */}
                    <p style={{fontSize: '1.125rem', lineHeight: '1.75rem', color: 'rgb(153,153,153)', fontWeight: 500}}>
                        For an in-depth tutorial on setting it up, visit our help center
                    </p>
                </div>
            </div>

            {/* Section - Content Block (Horizontal Spread) */}
            <div style={{padding: `${isMobile ? '2rem 1.5rem' : '4rem 1.5rem'}`, marginLeft: 'auto', marginRight: 'auto'}}>
                <div style={{display: 'grid', gridTemplateColumns: `${isTablet ? '1fr' : 'repeat(2,minmax(0,1fr))'}`, gap: '3rem'}}>
                    {/* Info + Button */}
                    <div>
                        <div style={{fontWeight: 500, fontSize: '1.25rem', color: '#ffc000', marginBottom: '1rem'}}>
                            Get Started
                        </div>
                        <h2 style={{fontSize: `${isMobile ? '2.25rem' : '3.75rem'}`, fontWeight: 'bold', padding: '.5rem 0', margin: `${isMobile ? '0' : '0 0 2rem'}`}}>
                            Subscribe to Interview Cheater
                        </h2>
                        <p style={{color: 'rgb(156,163,175)', fontSize: '1.25rem', lineHeight: '1.75rem', maxWidth: '42rem', margin: '0 0 2rem'}}>
                            Create an account and subscribe to Interview Cheater. Get instant access to our AI-powered interview solution generator.
                        </p>
                        <a href='/checkout'>
                            <button style={{background: 'transparent', color: '#FFFF00', fontWeight: 'bold', fontSize: '.875rem', padding: '.5rem 1.5rem .5rem 1.5rem', borderRadius: '14px', border: '1px solid #ffff00', width: `${isMobile ? '100%' : 'auto'}`, cursor: 'pointer'}}>
                                <div style={{display: 'flex', gap: '.5rem', alignItems: 'center', justifyContent: 'center'}}>
                                    Get Started
                                    <ChevronRightOutlinedIcon />
                                </div>
                            </button>
                        </a>
                    </div>
                    {/* Img */}
                    <div style={{width: '100%', overflow: 'hidden', maxWidth: '650px', width: '100%', minHeight: '180px', marginLeft: 'auto', marginRight: 'auto'}}>
                        <img alt="Screenshot" loading="lazy" decoding="async" src={auth_page_pic} style={{width: '100%', objectFit: 'cover'}} />
                    </div>
                </div>
            </div>

            {/* Section - Content Block (Horizontal Spread) */}
            <div style={{padding: `${isMobile ? '2rem 1.5rem' : '4rem 1.5rem'}`, marginLeft: 'auto', marginRight: 'auto'}}>
                <div style={{display: 'grid', gridTemplateColumns: `${isTablet ? '1fr' : 'repeat(2,minmax(0,1fr))'}`, gap: '3rem'}}>
                    {/* Img */}
                    {!isTablet && (
                        <div style={{width: '100%', overflow: 'hidden', maxWidth: '650px', width: '100%', minHeight: '180px', marginLeft: 'auto', marginRight: 'auto'}}>
                            <img alt="Screenshot" loading="lazy" decoding="async" src={screenshot_ft} style={{width: '100%', objectFit: 'cover'}} />
                        </div>
                    )}
                    {/* Info + Button */}
                    <div>
                        <div style={{fontWeight: 500, fontSize: '1.25rem', color: '#7c3aed ', marginBottom: '1rem'}}>
                            Capture the Problem
                        </div>
                        <h2 style={{fontSize: `${isMobile ? '2.25rem' : '3.75rem'}`, fontWeight: 'bold', padding: '.5rem 0', margin: `${isMobile ? '0' : '0 0 2rem'}`}}>
                            Start taking screenshots
                        </h2>
                        <p style={{color: 'rgb(156,163,175)', fontSize: '1.25rem', lineHeight: '1.75rem', maxWidth: '42rem', margin: `${isMobile ? '0' : '0 0 2rem'}`}}>
                            Use CTRL + H to capture the problem. Up to 2 screenshots will be saved and shown on the application.
                        </p>
                    </div>
                    {/* Img */}
                    {isTablet && (
                        <div style={{width: '100%', overflow: 'hidden', maxWidth: '650px', width: '100%', minHeight: '180px', marginLeft: 'auto', marginRight: 'auto'}}>
                            <img alt="Screenshot" loading="lazy" decoding="async" src={screenshot_ft} style={{width: '100%', objectFit: 'cover'}} />
                        </div>
                    )}
                </div>
            </div>

            {/* Section - Content Block (Vertical Spread) */}
            <div style={{padding: `${isMobile ? '2rem 1.5rem' : '4rem 1.5rem'}`, marginLeft: 'auto', marginRight: 'auto'}}>
                <div style={{display: 'grid', gridTemplateColumns: 'repeat(1,minmax(0,1fr))', gap: '3rem', marginLeft: `${isMobile ? '0' : '10%'}`}}>
                    {/* Info + Button */}
                    <div>
                        <div style={{fontWeight: 500, fontSize: '1.25rem', color: '#059669 ', marginBottom: '1rem'}}>
                            Solve
                        </div>
                        <h2 style={{fontSize: `${isMobile ? '2.25rem' : '3.75rem'}`, fontWeight: 'bold', padding: '.5rem 0', margin: `${isMobile ? '0' : '0 0 2rem'}`}}>
                            Get your solutions
                        </h2>
                        <p style={{color: 'rgb(156,163,175)', fontSize: '1.25rem', lineHeight: '1.75rem', maxWidth: '42rem', margin: `${isMobile ? '0' : '0 0 2rem'}`}}>
                            Once you've captured your screenshots, press CTRL + ENTER to generate solutions. We'll analyze the problem and provide a solution with detailed explanations.
                        </p>
                    </div>

                    <SampleSolutionBox />
                    
                </div>
            </div>

            {/* Section - Content Block (Vertical Spread) */}
            <div style={{padding: '2rem 1.5rem 0', marginLeft: 'auto', marginRight: 'auto'}}>
                <div style={{display: 'grid', gridTemplateColumns: 'repeat(1,minmax(0,1fr))', gap: '3rem', marginLeft: '10%'}}>
                    {/* Info + Button */}
                    <div>
                        <div style={{fontWeight: 500, fontSize: '1.25rem', color: '#6d28d9', marginBottom: '1rem'}}>
                            Toggle Window
                        </div>
                        <h2 style={{fontSize: `${isMobile ? '2.25rem' : '3.75rem'}`, fontWeight: 'bold', padding: '.5rem 0', margin: `${isMobile ? '0' : '0 0 2rem'}`}}>
                            Hide the app quickly
                        </h2>
                        <p style={{color: 'rgb(156,163,175)', fontSize: '1.25rem', lineHeight: '1.75rem', maxWidth: '42rem', margin: `${isMobile ? '0' : '0 0 2rem'}`}}>
                            Toggle the visibiliy of the window while keeping your cursor on the interview. Seamlessly switch without raising suspicion.
                        </p>
                    </div>

                    {/* Img */}
                    <div style={{width: '100%', overflow: 'hidden', maxWidth: '1024px', width: '100%', minHeight: '180px', marginRight: 'auto'}}>
                        <video className='video feature' muted loop playsInline controlsList='nodownload' disablePictureInPicture disableRemotePlayback autoPlay>
                            <source type='video/mp4' src={demo_6} />
                        </video>
                    </div>
                </div>
            </div>

        </Fragment>  
	);
}
  
export default HowTo;
  